import { TypePolicies } from '@apollo/client'

/**
 * How Apollo's cache identifies objects that carry no `id`.
 *
 * ENGG-10387 (code review): a `ConnectedSource` (`connectedSources`, a meeting
 * source's connection state) is one object per source key, read by two queries
 * on the Call Recorder page — the Avoma card's `GET_CONNECTED_SOURCES` and the
 * Gong card's `GET_GONG_SALES_ROOM_SOURCE`, which asks for `lookbackDays` too —
 * and written by `updateMeetingSourceSettings`. Keyed by `key`, every write
 * merges into the one record: the Avoma card's refetch no longer drops the
 * field only the Gong section reads (which made that section refetch and flash
 * "Loading"), and the save's own answer flips the Gong switch at once rather
 * than after the status read that follows it.
 */
export const cacheTypePolicies: TypePolicies = {
  ConnectedSource: { keyFields: ['key'] },
  // ENGG-10450 (code review): a Content Hub item's id is unique only WITHIN
  // its source (assetKey.ts) — uploads and Drive/Notion/Confluence rows have
  // their own id sequences. Keyed by `id` alone, upload 42 and Drive file 42
  // (a variant's `source`, the All Files view) were one record and overwrote
  // each other's card. Apollo throws on a write that lacks a key field, so
  // every selection of a ContentBrowseItem asks for `source`
  // (cacheTypePolicies.test.ts checks every document in src/graphql for it).
  ContentBrowseItem: { keyFields: ['source', 'id'] },
  // ENGG-10450: `clientConfig` has no id, so it lives inside ROOT_QUERY and a
  // second query selecting fewer of its fields (the content personalization
  // card's GET_CONTENT_PERSONALIZATION_SETTING) would REPLACE the object the
  // app-wide ClientConfig read filled — and useClientConfig, which reads
  // cache-only, would then see a config with every other flag missing. Merging
  // keeps one object that both selections write into.
  Query: { fields: { clientConfig: { merge: true } } },
}
